module.exports = __webpack_public_path__ + "media/images/branding-example-f026098739e96406a0745e42a12e2cb4.png";